import { useId, useState } from 'react';
import Select from 'react-select';
import {
  Option,
  MultiValueRemove,
  MenuList,
  DropdownIndicator,
} from './selectComponents';
import { useMultiSelectValue, useAsyncOptions } from './hooks';
import * as styles from './index.module.css';

export function AsyncSelectMulti({
  value = [],
  onChange,
  placeholder = 'Select...',
  isDisabled = false,
  closeMenuOnSelect = false,
  hideSelectedOptions = false,
  loadOptions,
  filterType,
  cachedOptions = null,
  enableDebouncedSearch = true,
}) {
  const instanceId = useId();
  const [inputValue, setInputValue] = useState('');

  const { options, isLoading, handleMenuOpen } = useAsyncOptions({
    loadOptions,
    filterType,
    cachedOptions,
    searchInputValue: enableDebouncedSearch ? inputValue : '',
  });

  const { selectedOptions, handleChange } = useMultiSelectValue(
    options,
    value,
    onChange,
  );

  const handleInputChange = (newValue, actionMeta) => {
    // Only update on user input, not on menu close
    if (actionMeta.action === 'input-change') {
      setInputValue(newValue);
    }
  };

  const noOptionsMessage = () => {
    if (isLoading) return 'Loading...';
    return options.length === 0 ? 'No options available' : 'No matches found';
  };

  return (
    <div className={styles['select-multi']}>
      <Select
        instanceId={instanceId}
        isMulti
        options={options}
        value={selectedOptions}
        onChange={handleChange}
        onInputChange={handleInputChange}
        inputValue={inputValue}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={false}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        noOptionsMessage={noOptionsMessage}
        onMenuOpen={handleMenuOpen}
        components={{
          Option,
          MultiValueRemove,
          MenuList,
          DropdownIndicator,
        }}
        classNamePrefix="select-multi"
        menuPortalTarget={document.body}
        menuPosition="fixed"
      />
    </div>
  );
}
